import { clientPublicService } from 'helper/axios'

export const getHelpdeskWidget = async ({ token }) => {
  try {
    return await clientPublicService
      .post('core/helpdesk/authenticate', {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error?.response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
